import React, { useEffect, useState } from "react";
import HeroImage1 from "../../assets/hero-img-slider-1.jpg";
import HeroImage2 from "../../assets/hero-img-slider-2.jpg";
import HeroImage3 from "../../assets/hero-img-slider-3.jpg";
import HeroImage4 from "../../assets/hero-img-slider-4.jpg";
// import Logo from "../../assets/nym.png";

const Hero = () => {
  const images = [HeroImage1, HeroImage2, HeroImage3, HeroImage4];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 4000); // every 4 seconds

    return () => clearInterval(interval);
  },);

  const handleNext = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
      setFade(true);
    }, 200);
  };



  const goToIndex = (index: number) => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex(index);
      setFade(true);
    }, 100);
  };


  return (
    <div className="relative text-black overflow-hidden">
      {/* Background circles */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full bg-blue-500"
              style={{
                width: `${Math.random() * 10 + 5}px`,
                height: `${Math.random() * 10 + 5}px`,
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                opacity: Math.random() * 0.5 + 0.2,
              }}
            />
          ))}
        </div>
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full blur-3xl"
            style={{
              width: `${Math.random() * 400 + 200}px`,
              height: `${Math.random() * 400 + 200}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
          />
        ))}
      </div>

      <main className="max-w-7xl mx-auto px-6 py-10 md:py-20 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Column */}
          <div className="space-y-8">
            <div className="flex items-center space-x-3">
              {/* <div className="backdrop-blur-md p-3 rounded-2xl">
                <img className="w-10 h-10 object-contain" src={Logo} alt="NYM Technology Limited" />
              </div> */}
              {/* <div className="h-px w-20 bg-blue-500"></div>
              <span className="text-sm font-medium tracking-wider text-blue-400 uppercase">Technology</span> */}
            </div>

            <div className="space-y-4">
              <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold leading-tight">
                <span className="bg-clip-text text-transparent bg-black font-bold">
                  Driving Innovation Through Cutting-Edge Technology & Research
                </span>
              </h1>
              <p className="text-md text-gray-700 max-w-lg">
                At NYM Technology, we build powerful, user-friendly software designed to streamline operations,
                boost productivity, and drive growth. From schools to retail businesses, our systems are built
                to scale with you.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium transition-all
               duration-300 shadow-lg shadow-blue-600/20 hover:shadow-blue-600/30"
                onClick={() => window.location.href = "/about"}>
                Learn More
              </button>
              <button className="bg-transparent border border-blue-500 text-blue-500 px-8 py-3 rounded-lg
               font-medium transition-all duration-300"
                onClick={() => window.location.href = "/product"}>
                Our Products
              </button>
            </div>

            <div className="flex items-center space-x-4 pt-6">
              <div className="flex -space-x-2">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-purple-500 border-2
                     border-gray-900 flex items-center justify-center text-xs font-bold"
                  >
                    {String.fromCharCode(65 + i)}
                  </div>
                ))}
              </div>
              <p className="text-sm text-gray-400">Trusted by leading tech companies</p>
            </div>
          </div>

          {/* Right Column (Image Slider) */}
          <div className="relative group">
            <div className="absolute inset-0 rounded-3xl blur-3xl"></div>
            <div className="relative p-1 rounded-3xl shadow-2xl transition-all duration-500">
              <div className="bg-gray-900 rounded-[22px] p-2">
                <img
                  src={images[currentImageIndex]}
                  alt="Technology"
                  className={`w-full h-auto rounded-2xl object-cover transition-opacity duration-1000 
                    ${fade ? "opacity-100" : "opacity-0"
                    }`}
                />
              </div>
            </div>

            {/* Controls */}

            {/* Dots */}
            <div className="flex justify-center mt-4 gap-2">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => goToIndex(idx)}
                  className={`w-3 h-3 rounded-full transition ${currentImageIndex === idx ? "bg-blue-600" : "bg-gray-400"
                    }`}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Hero;
